import { useEffect, useState } from "react";
import FormYearMonth from '../components/form-year-month';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { JobExperiencesModel, SignupModelHelper } from "../data/SignupModel";
import { months } from '../data/months';
import { AmplitudeService } from '../services/AmplitudeService';

export default function ExperienciaEntrada(props: any) {

  const [interactions, setInteractions] = useState<InteractionModel[]>([]);
  const [experience, setExperience] = useState<JobExperiencesModel | null>(null);

  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    // TagManager.dataLayer(dataLayerHelper.pagina('entrada', 'experiencia'));
    AmplitudeService.track('Experience Begin Date Screen')
    setExperience(SignupModelHelper.getOngoingExperience());
  }, [])

  function setEntranceDate(yearMonth: string) {
    const maxYear = new Date().getFullYear();
    const [year] = yearMonth.split('-');
    const startDate = new Date(yearMonth + "-01T12:00");
    const today = new Date();
    today.setHours(12);

    const chat = [...interactions, {
      text: `${months[startDate.getMonth()]} de ${startDate.getFullYear()}`,
      author: InteractionAuthor.CLIENTE
    }];
    setInteractions(chat);


    if (isNaN(+year) || +year < 1900) {
      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Informe um ano entre 1900 e ${maxYear}`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else if (startDate > today) {
      setTimeout(() => {
        const nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Selecione um mês anterior a ${months[nextMonth.getMonth()]} de ${nextMonth.getFullYear()}.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    } else {
      SignupModelHelper.updateExperience({ start: startDate });
      AmplitudeService.track('Experience Begin Date Submit')
      document.location = experience?.current ? '#/experiencia-adicionar-outra' : '#/experiencia-saida';
    }
  }

  return (
    <>
      <Header step={ 6 } total={ 8 } title="Adicionar experiência" previous="#/experiencia-ainda-trabalha"></Header>

      <FormYearMonth
        lastAnswer={ experience?.current === true ? 'Sim, é meu cargo atual' : 'Não, já saí dessa empresa' }
        question="Então, me conta <strong>quando você entrou</strong> na empresa."
        onSubmit={ setEntranceDate }
        interactions={ interactions }
      />
    </>);
}
